// @flow
export type ActionType = 'HEADER/INIT';

export type Action = {
    type: ActionType,
    payload: {}
};

export const HEADER_INIT = 'HEADER/INIT';

const ACTION_CREATORS = {
    initHeader(header: {}): Action {
        return {type: HEADER_INIT, payload: header};
    }
};

export default {
    ...ACTION_CREATORS
};
